import { Injectable } from '@angular/core';
import { Converter } from '../../converter.interface';
import { isNullOrUndefined } from 'util';
import { StringUtils } from 'src/app/services/utils/string.utils';
import { OrderDetailsProcessObject } from 'src/app/models/orders/order-details-process/order-details-process-object.model';
import { ProcessTableObject } from 'src/app/models/orders/order-details-process/process-table/process-table-object.model';
import { ProcessDetailsObject } from 'src/app/models/orders/order-details-process/process-details/process-details-object.model';

@Injectable({
    providedIn: 'root'
})
export class OrderDetailsProcessConverter implements Converter<Array<OrderDetailsProcessObject>> {

    process;
    processes: Array<OrderDetailsProcessObject>;
    constructor() { }

    convert(input: any): Array<OrderDetailsProcessObject> {
        if (isNullOrUndefined(input)) {
            return new Array<OrderDetailsProcessObject>();
        }
        this.processes = new Array<OrderDetailsProcessObject>();
        for (this.process of input.processes) {

            this.process = new OrderDetailsProcessObject(StringUtils.default(this.process.id),
                StringUtils.default(this.process.type), StringUtils.default(this.process.name),
                StringUtils.default(this.process.status), ProcessTableObject.create(), ProcessDetailsObject.create());
            this.processes.push(this.process);
        }
        return this.processes;
    }
}